// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-laptop';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M8.357 5.143a3.214 3.214 0 1 0 6.429 0 3.214 3.214 0 1 0-6.429 0m9 10.928a5.786 5.786 0 0 0-6.428-5.75m-2.572-.678H.643l1.286 6.428h7.714L8.357 9.643Zm1.286 6.428H13.5'
  />
);

export const viewBox = '0 0 18 18';
